import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "manager-container"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "nickname"
};
const _hoisted_4 = {
  class: "role-progress-container"
};
const _hoisted_5 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_6 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_7 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_8 = {
  class: "role-data-container"
};
const _hoisted_9 = {
  class: "item-card"
};
const _hoisted_10 = {
  class: "item-value"
};
const _hoisted_11 = {
  class: "item-card"
};
const _hoisted_12 = {
  class: "item-value"
};
const _hoisted_13 = {
  class: "item-card"
};
const _hoisted_14 = {
  class: "item-value"
};
const _hoisted_15 = {
  class: "item-card"
};
const _hoisted_16 = {
  class: "item-value"
};
const _hoisted_17 = {
  class: "item-card"
};
const _hoisted_18 = {
  class: "item-value"
};
const _hoisted_19 = {
  class: "item-card"
};
const _hoisted_20 = {
  class: "item-value"
};
import { computed } from 'vue';
import { ElImage, ElProgress, ElRow } from 'element-plus';
import { getGender, getPercentage } from "@/tools/utils";
import { featOptions } from "@/tools/utils";
import 'element-plus/es/components/progress/style/css'; // pre-declaration

export default {
  __name: 'StageRolesManager',
  props: {
    data: {
      type: Object,
      required: true
    },
    actor: {
      type: Array,
      required: true
    },
    onlineActor: {
      type: Array,
      required: true
    }
  },
  emits: ['clickRole'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // computed

    const dataArray = computed(() => {
      if (!props.data || !props.actor) return [];
      const roleDataKeys = Object.keys(props.data); // console.log('roleDataKeys', JSON.stringify(roleDataKeys))
      // console.log('props.actor', JSON.stringify(props.actor))

      if (roleDataKeys.length < props.actor.length) return [];
      return props.actor.map(role => {
        return { ...{
            'ticket': role
          },
          ...(props.data[role.id] ?? {})
        };
      });
    });

    const getOrganizationDesc = role_sign => {
      if (!role_sign || !role_sign.organization) return '无组织';

      if (role_sign.organization === 0) {
        return `${role_sign.organization}`;
      } else {
        return `${role_sign.organization}(${featOptions[role_sign.feats_level - 1]})`;
      }
    };

    const getRoleSignDesc = role_sign => {
      if (!role_sign) return '';
      const nationality = role_sign.nationality ?? '未知国家';
      const age = role_sign.age ? `${role_sign.age}岁` : '未知年岁';
      const race = role_sign.race ?? '未知人种';
      const gender = getGender(role_sign.gender ?? 0);
      return `${nationality} / ${age} / ${race} / ${gender}`;
    };

    const clickRole = role => {
      emits('clickRole', role.ticket.id);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (role, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "role-card",
          key: index,
          onClick: $event => clickRole(role)
        }, [_createVNode(_unref(ElRow), {
          class: "role-info-container"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(role.ticket.nickname), 1), _createTextVNode(" " + _toDisplayString(getOrganizationDesc(role.role_sign)) + "   " + _toDisplayString(getRoleSignDesc(role.role_sign)), 1)])]),
          _: 2
        }, 1024), _createVNode(_unref(ElRow), {
          class: "role-status-container"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["avatar-container", __props.onlineActor.includes(role.ticket.id) ? 'is_online' : ''])
          }, [_createVNode(_unref(ElImage), {
            src: role.ticket.avatar,
            fit: "cover",
            draggable: "false"
          }, null, 8, ["src"])], 2), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(role.role_status.hp, role.role_status.max_hp),
            "text-inside": true,
            "stroke-width": 16,
            class: "item-progress hp_progress"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_5, _toDisplayString(`${role.role_status.hp} / ${role.role_status.max_hp}`), 1)]),
            _: 2
          }, 1032, ["percentage"]), _createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(role.role_status.mp, role.role_status.max_mp),
            "text-inside": true,
            "stroke-width": 16,
            class: "item-progress mp_progress"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_6, _toDisplayString(`${role.role_status.mp} / ${role.role_status.max_mp}`), 1)]),
            _: 2
          }, 1032, ["percentage"]), _createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(role.role_status.san, role.role_status.max_san),
            "text-inside": true,
            "stroke-width": 16,
            class: "item-progress san_progress"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_7, _toDisplayString(`${role.role_status.san} / ${role.role_status.max_san}`), 1)]),
            _: 2
          }, 1032, ["percentage"])])]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[0] || (_cache[0] = _createElementVNode("text", {
          class: "item-title"
        }, " 神秘 ", -1)), _createElementVNode("text", _hoisted_10, _toDisplayString(role.role_sign.mysterious_level), 1)]), _createElementVNode("div", _hoisted_11, [_cache[1] || (_cache[1] = _createElementVNode("text", {
          class: "item-title"
        }, " 神话 ", -1)), _createElementVNode("text", _hoisted_12, _toDisplayString(role.role_status.mythology), 1)]), _createElementVNode("div", _hoisted_13, [_cache[2] || (_cache[2] = _createElementVNode("text", {
          class: "item-title"
        }, " 肉体强度 ", -1)), _createElementVNode("text", _hoisted_14, _toDisplayString(role.role_sign.damage_bonus), 1)]), _createElementVNode("div", _hoisted_15, [_cache[3] || (_cache[3] = _createElementVNode("text", {
          class: "item-title"
        }, " 灵体强度 ", -1)), _createElementVNode("text", _hoisted_16, _toDisplayString(role.role_sign.pow_damage_bonus), 1)]), _createElementVNode("div", _hoisted_17, [_cache[4] || (_cache[4] = _createElementVNode("text", {
          class: "item-title"
        }, " 资产 ", -1)), _createElementVNode("text", _hoisted_18, _toDisplayString(role.role_status.wealth_point), 1)]), _createElementVNode("div", _hoisted_19, [_cache[5] || (_cache[5] = _createElementVNode("text", {
          class: "item-title"
        }, " 移动力 ", -1)), _createElementVNode("text", _hoisted_20, _toDisplayString(role.role_sign.movement), 1)])])], 8, _hoisted_2);
      }), 128))]);
    };
  }

};